<template>
	<div>
   
    
      <search v-show="!$root.app.hideSearch" class="searchInboxOpen" id="search" ref="searchComp"></search> 

      <div ref="bundlesContent1">
        <div @click="toggleInbox" class="handCursor inboxOpener" id="inboxOpenerContainer" >
          <div id="inboxOpener" class=" is-hidden-desktop has-text-centered " @dragenter="handleInboxLabelDragOver($event)"  >i<br>n<br>b<br>o<br>x</div>
        </div>
  
        <div id="leftBar">
          <inbox ref="theInbox" v-if="$root.app.tree[0]" v-bind:info="$root.app.tree[0]" v-bind:listIndex="0" class="wobuListVif"></inbox> 
        </div>
      </div>

  <div ref="bundlesContent2" class="is-inline" >
   
   <div id="boardHeader" class="boardInboxOpen">
          <div class="is-size-4 bundlesHeading " >
            <div class="bundlesSubHeading" >
               <span class="newBundleBt is-size-6" @click="newBundle" v-tooltip="'New Bundle'"><b>+</b></span>
              
              &nbsp;<span class="bundlesTitle has-text-grey" @click="getIndexOfRootBundle" ><b>BUNDLES</b></span>&nbsp;
              <div class="is-inline-block"><i id="refreshBt" class="fa fa-sync-alt has-text-coolGreen  handCursor left5" @click="$root.app.loadUserBundles()" v-tooltip="'refresh'"></i></div>
             
             
    
              </div>
          </div>
  
          <div class="posRel"><div v-show="!showToggles" id="prefsButt" class=" prefsButt  has-text-white" @click="openToggles"><i class="fas fa-eye "></i></div></div>
          
         <div class="posRelative" :class="{'hideItMobile': inbox}">
           
             <div class="groupFilter is-inline-block">
             
  
                <div id="bundleGroupsDropSelected" v-if="!bundleGroupsDrop" class="is-inline-block" @click="(e) => {e.stopPropagation(); bundleGroupsDrop = true}">
                      <span class="bundleGroupDropItemSelected has-text-white">{{$root.app.currBundleGroup}}<div class="is-inline-block left2 has-text-coolGreen"><i class="fa fa-sort-down"></i></div></span>
                </div>
  
                <div v-if="bundleGroupsDrop" class="is-inline-block" id="bundleGroupDrop">
                    <div class="bundleMenuItem" @click="viewChanged(0, 'All')">All</div>
                    <div class="bundleMenuItem" v-for="(item, i) in $root.app.bundleGroups" :key="i" :value="item.id" @click="viewChanged(item.id, item.name)">{{item.name}}</div>
                    <div class="bundleMenuItem top1" @click="viewChanged(-1, '')"><button class="button is-coolGreen is-small xs">Manage</button></div>
                </div>
  
            </div>
            
            <div v-show="showToggles" class="toggles">
                <div class="bundlePrefs">
                  <div class="bundleMenuItem"  @click="toggleViews"><i class="fa fa-window-maximize is-size-6 handCursor sortControlButt" ></i>{{!$root.app.fulled ? 'single-' : 'multi-'}}bundle view</div>
                  <div class="bundleMenuItem">---</div>
                  <div class="bundleMenuItem"  @click="toggleContext"><i class="fa fa-pen is-size-6 handCursor sortControlButt" ></i>{{!$root.app.showContext ? 'show ' : 'hide '}}notes</div>
                  <div class="bundleMenuItem"  @click="toggleRatings"><i class="fas fa-star is-size-6 handCursor sortControlButt" ></i>{{$root.app.showRatings ? 'hide' : 'show'}} ratings</div>
                  <div class="bundleMenuItem" :class="{disabledCheckbox: $root.app.userAttrs.bundleLimit > 0}"  @click="toggleAds"><i class="fa fa-ad is-size-6 handCursor sortControlButt" ></i>{{!$root.app.showAds ? 'show ' : 'hide '}}ads</div>
                  <div class="bundleMenuItem">---</div>
                  <div class="bundleMenuItem"><b>BETA:</b></div>
                  <div class="bundleMenuItem"  @click="toggleImages"><i class="fa fa-image is-size-6 handCursor sortControlButt" ></i>{{$root.app.showImages ? 'hide' : 'show'}} images</div>
                  <div class="bundleMenuItem"  @click="toggleBundles"><i class="fa fa-compress is-size-6 handCursor sortControlButt" ></i>{{$root.app.bundlesOpen ? 'collapse' : 'expand'}} bundles</div>
                  
                
                </div>
              &nbsp;&nbsp;&nbsp;        
            </div>
         </div>
   </div>
       
        <!-- LISTS: -->        
      
          <div id="board"  class="loaderOffset">

            <div id="listsHolder" :class="{scrollNoVert: $root.app.fulled}" class="listsHolderInboxOpen" >
              <div class="fulledHeader" >
                <div class="posRelative">

                </div>
              </div>
              <div v-show="$root.app.fulled" class="fulledBundlesContainer"> 
                <div v-for="(item2, i2) in currView" :key="i2" class="fulledBundlelabel" @click="loadFulledBundle(item2.id)" :class="{fulledBundleLableSelected: $root.app.fulledBundle == item2.id}">
                   <span class="has-text-coolGreen" ><b :class="{'has-text-grey': $root.app.fulledBundle == item2.id}">:: </b></span>{{item2.listName}}&nbsp;
                </div>
              </div>

              <div id="lists"   :class="{hasBGeee: $root.app.fulled, fulledListSPos: $root.app.fulled}" ref="lists">
                <bundle v-for="(item, index) in $root.app.treeNoInbox" :key="index" v-bind:info="$root.app.treeNoInbox[index]" v-bind:listIndex="index" ref="rootBundleContainers"></bundle> 
                <root-drop v-if="!$root.app.fulled"></root-drop>
             
              </div>
              <scroll-helper v-show="scrollHelpers" style="position: fixed; top: 108px" :dir="-1" ></scroll-helper>
              <scroll-helper v-show="scrollHelpers" style="position: fixed; bottom: 0" :dir="1"></scroll-helper>
            </div>
            
          </div>
      </div>

     

      <AZWindow ref="theWindow" v-show="windowOpen && !showMinWindow" ></AZWindow>

      <div v-show="showMinWindow" id="minWindow" @click="maximizeWindow"><i class="fa fa-window-maximize"></i><span class="has-text-coolGreen"><b> ::</b></span><b>{{minWindowTitle}}</b> </div>

     

    <div id="animation">
      <div>
        <img src="@/assets/img/animation1c.gif" />
      </div>
    </div>
          
	</div>
</template>

<script>
  import { Drag, Drop } from 'vue-drag-drop'
  import LinkPrevue from '../components/LinkPrevue.vue'
  import Inbox from '../components/Inbox.vue'
  import Bundle from '../components/Bundle.vue'
  import { ToggleButton } from 'vue-js-toggle-button'
  import NewLister from '../components/NewLister'
  import TagBar from '../components/TagBar'
  import RootDrop from '../components/RootDrop'
  const request = require('request');
  import ModalNewSub from '../components/ModalNewSub'
  import bFactory from '../shared/bundleFactory.js'
  import { AZEventBus } from '../components/AZEventBus'
  import AZWindow from '../components/Window.vue'
  import Search from '../components/Search.vue'
  import ScrollHelper from '../components/ScrollHelper'
  

	export default {
    components: {Drag, Drop, LinkPrevue, Inbox, ToggleButton, NewLister, RootDrop, TagBar, Bundle, AZWindow, Search, ScrollHelper},
    data: function(){
      return {
        goUrl: '',
        showUrlBar: false,
        windowOpen: false,
        bundleIndexForWindow: null,
        currOpenWindow: null,
        showMinWindow: false,
        inited: false,
        showToggles: false,
        inbox: true,
        scrollHelpers: false,
        currView: [],
        bundleGroupsDrop: false,
   
       
      }
    },
    mounted: function(){

      var self = this;
      
      if(document.getElementById('inboxOpener'))
        document.getElementById('inboxOpener').classList.add('inboxOpenerHidden')

      if(this.$route.query.prev != 1){
        this.$root.app.loaded = false
        this.$root.app.loadUserBundles()
      }

      AZEventBus.$on('closeAllMenus', this.closeAllMenusHandler)

  
      function init(){
     
      }

      if(self.$root.app.doneFederating){
          self.inited = true
          init();
      }

      AZEventBus.$once('onFederate', msg => {
        if(self.inited == false)
          init();
      });

     /*  AZEventBus.$on('setRootDirtyAlert', msg => {
        self.$refs.rootBundleContainers[msg.slotBundle].hasDirtyChildren = msg.isDirty
      }) */

      let i = document.getElementById('leftBar')
      let h  = document.getElementById('inboxOpener')
      let b = document.getElementById('board')
      let l = document.getElementById('listsHolder')
      let s = document.getElementById('search')
      let bh = document.getElementById('boardHeader')
      let pb = document.getElementById('prefsButt')


      i.classList.remove('inboxHidden')
      h.classList.add('inboxOpenerHidden')
      b.classList.add('boardInboxOpen')
      //l.classList.add('listsHolderInboxOpen')
      s.classList.add('searchInboxOpen')
      bh.classList.add('boardInboxOpen')
      pb.classList.add('prefsButtInboxOpen')

      this.inbox = true
     
      
      var inter = setInterval(function(){
        
        if(self.$root.app.loaded){
          
          if(self.$root.currBundleGroupId == 0){
            self.currView = self.$root.app.treeNoInbox;
            clearInterval(inter)
            return
          } else {
            
            var v = self.$root.app.bundleGroups.find(e => {
              return e.id == self.$root.app.currBundleGroupId
            })
           
            if(v == undefined){
              self.currView = self.$root.app.treeNoInbox;
              clearInterval(inter)
              return
            }
            var arr = self.$root.app.treeNoInbox.slice(0)
            var arr2 = arr.filter(e => {
              return v.contents.includes(e.id)
            })
            self.currView = arr2
          }

       

          clearInterval(inter)
        } else {
          
        }
      },1000)

    },

    beforeDestroy: function(){
      AZEventBus.$off('closeAllMenus', this.closeAllMenusHandler)
    },

  

		methods: {

      closeAllMenusHandler: function(msg){
          this.showToggles = false   
          this.bundleGroupsDrop = false   
          this.filterTypeDrop = false  
      },
      
    
      toggleInbox: function(){

          let i = document.getElementById('leftBar')
          let h  = document.getElementById('inboxOpener')
          let b = document.getElementById('board')
          let l = document.getElementById('listsHolder')
          let s = document.getElementById('search')
          let bh = document.getElementById('boardHeader')
          let pb = document.getElementById('prefsButt')

         
         if(this.inbox){
           this.inbox = false
           i.classList.add('inboxHidden')
           h.classList.remove('inboxOpenerHidden')
           b.classList.remove('boardInboxOpen')
           l.classList.remove('listsHolderInboxOpen')
           s.classList.remove('searchInboxOpen')
           bh.classList.remove('boardInboxOpen')
           pb.classList.remove('prefsButtInboxOpen')

           
         } else {
            this.inbox = true
           i.classList.remove('inboxHidden')
           h.classList.add('inboxOpenerHidden')
           b.classList.add('boardInboxOpen')
           l.classList.add('listsHolderInboxOpen')
           s.classList.add('searchInboxOpen')
           bh.classList.add('boardInboxOpen')
           pb.classList.add('prefsButtInboxOpen')
 
          
         }
      },

      go: function(){
        if(this.goUrl == '') return

        var obj = {
          dataTransfer: {}
        };
        obj.dataTransfer.url = this.goUrl
        obj.preventDefault = function(){}
        obj.dataTransfer.getData = function(){
         return this.url;
        }
        this.handleDrop({}, obj);
        this.goUrl = ''
      },
			handleDrop(data, event) {
       event.preventDefault();
       this.$root.app.doShowModal('editModal', {url: this.sanitizeURL(event.dataTransfer.getData('URL'))})
			 //console.log(event.dataTransfer.getData('URL'));
      },
      more: function(url){
        window.open(url, '_blank');
      },
      toggleImages: function(){
        this.$root.app.showImages = !this.$root.app.showImages
        function w(d){
         
        }
        function n(){

        }
        this.$root.app.apiClient.put('subs/data/state', {param: 1, val: this.$root.app.showImages ? 1 : 0}, w, n)
      },
      toggleAds: function(){

       

        if(this.$root.app.userAttrs.bundleLimit > 0){
                if(this.$root.app.inApp){
                  this.$root.app.showModalOK({message: 'To enable this functionality please visit your account settings from a web browser.'})
                } else {
                    this.$root.app.doShowModal('ModalUpg', {msg: 'ads'})
                }
                return
        } 

        this.$root.app.showAds = !this.$root.app.showAds
        function w(d){
         
        }
        function n(){

        }
        this.$root.app.apiClient.put('subs/data/state', {param: 7, val: this.$root.app.showAds ? 1 : 0}, w, n)
      },
      toggleBundles: function(){
        this.$root.app.bundlesOpen = !this.$root.app.bundlesOpen
        function w(d){
         
        }
        function n(){

        }
        this.$root.app.apiClient.put('subs/data/state', {param: 2, val: this.$root.app.bundlesOpen ? 1 : 0}, w, n)
      },
      toggleRatings: function(){
        this.$root.app.showRatings = !this.$root.app.showRatings
        function w(d){
         
        }
        function n(){

        }
        this.$root.app.apiClient.put('subs/data/state', {param: 3, val: this.$root.app.showRatings ? 1 : 0}, w, n)
        
      },
      toggleViews: function(){
        this.$root.app.fulled = !this.$root.app.fulled
        if(this.$root.app.fulled){
          this.$root.app.fulledBundle = this.currView[0].id
        }
        document.getElementById('listsHolder').scrollTo(0,0)
        function w(d){
         
        }
        function n(){

        }
        this.$root.app.apiClient.put('subs/data/state', {param: 4, val: this.$root.app.fulled ? 1 : 0}, w, n)



      },
      toggleContext: function(){
        this.$root.app.showContext = !this.$root.app.showContext
        function w(d){
         
        }
        function n(){

        }
        this.$root.app.apiClient.put('subs/data/state', {param: 6, val: this.$root.app.showContext ? 1 : 0}, w, n)

      },
      sanitizeURL: function(url){
        var newURL = url.split('://');

        if (newURL.length == 1){
          return  'http://' + url
        }

        return url
      },
      handleInboxLabelDragOver: function(data, event){
         //event.preventDefault()
         console.log(data)
         //if(data && data.type == 'card'){
              //this.counter++;
              //this.dragging = true;
              if(!this.inbox){
                this.toggleInbox()
              }
         //}
      },
      newBundle: function(){
          this.$root.app.nextTourStep();

          this.$root.app.loadedModalComponent = ModalNewSub;
          this.$root.app.modalPropsObj = {callBack: this.saveBundle, sub: false, selectedId: 0, selectedAliasId: 0}
          this.$root.app.showModal = true
      },
      saveBundle: function(bundleName, collabId, toInclude, isCollab, wrapperId, aliasTgtId){
    

          var self = this;

                   
          function rec(arr){
           
            var res = null

            function rec2(arr2){
              for(var x=0; x < arr2.length; x++){
                if(arr2[x].id == wrapperId){
                  res = arr2[x]
                  break
                }
                if(arr2[x].children.length){
                  rec2(arr2[x].children)
                }
              }
            }

            rec2(arr)
            
            return res

          }

          function w(data){

            if(data == 'miimu limit exceeded'){
                if(!self.$root.app.inApp)
                    self.$root.app.doShowModal('ModalUpg', {limit: 'b'})
                else
                    self.$root.app.doShowModal('ModalOK', {message: `Congratulations! You've created a ton of bundles! To create more, please visit your account settings from any web browser.`})

                return
            }

            let bId = data.response
            let newBranch = [bId]
            
            let b = bFactory(bId, true, bundleName, newBranch)
            
            if(collabId || data.collabId)
              b.collabId = collabId || data.collabId
            b.id_cog = self.$root.app.userAttrs.sub

            self.$root.app.bundles.push(b);

            if(wrapperId == 0){
              if(self.$root.app.treeNoInbox.length)
                b.p = self.$root.app.treeNoInbox[0].p / 2
              else
                b.p = 16000
              self.$root.app.treeNoInbox.push(b)
      
              setTimeout(function(){
                  self.$root.app.treeNoInbox.sort((a,b) => {
                    return a.p - b.p
                  }, 5)
              })
            } else {
              
              //find parent and add new bundle to its children
              
              var tgB = rec(self.$root.app.treeNoInbox)
              tgB.children.push(b)
             

            }

            if(data.newGroup){
              data.newGroup.forEach(e => {
                self.$root.app.groupMembers.push(e)
              })
            }
            document.getElementById('listsHolder').scrollTo(0,0)
          }

          function n(){

          }

          //TODO implement proximity check
          let p
          if(self.$root.app.treeNoInbox[0])
            p = self.$root.app.treeNoInbox[0].p / 2
          else
            p = 16000

          if (p < 1.8e-38)
            p = 1.8e-38

          let tTemp = aliasTgtId || wrapperId
          if(tTemp == 0)
            tTemp = 'root'

          var checkLimits = this.$root.app.checkLimits
          self.$root.app.apiClient.post('subs/data/bundle', {checkLimits: checkLimits, name: bundleName, collabId: collabId, toInclude: toInclude, isCollab: isCollab, isRoot: wrapperId == 0 ? true : false, targetBundle: tTemp, p: p}, w, n);

          
      },
      toggleUrlBar: function(){
        this.showUrlBar = !this.showUrlBar
      },
      closeAllMenus: function(){
        AZEventBus.$emit('closeAllMenus', {})
      },
      loadFulledBundle: function(id){
        this.$root.app.fulledBundle = id
        document.getElementById('listsHolder').scrollTo(0,0)
      },
      openWindow: function(id, listIndex, rootId){

        /* if(this.$root.app.inApp){
            this.$root.app.blurBG()
        } */
  
        this.closeWindow()
        var unCat = false

        if(id == 'uncat'){
          unCat = true
          id = this.$root.app.bundles.find(e => {
              return e.isUncat == 1
          }).id
        }


        if(this.currOpenWindow != null && !unCat)
          this.$refs.rootBundleContainers[this.currOpenWindow].$el.classList.remove('bMinimized')

        let ind = this.$root.app.bundles.findIndex(e => {
            return e.id == id || e.aliasTgtId == id
        })  

        if(!unCat){
          let rootIndex = this.$root.app.treeNoInbox.findIndex(e => {
              return e.id == rootId
          }) 
          this.$refs.rootBundleContainers[listIndex].$el.classList.add('bMinimized')

           
          this.$refs.theWindow.rootIndex = rootIndex 
        }

        this.$refs.theWindow.bundleIndex = ind

        this.currOpenWindow = listIndex

        this.windowOpen = true
        this.showMinWindow = false
        var self = this;
        setTimeout(
          function(){
            self.$refs.theWindow.$refs.window.asyncLoadItems()
          }, 10
        )
        
      },

      closeWindow: function(listIndex){
        /* if(this.$root.app.inApp){
            this.$root.app.blurBG()
        } */
        this.windowOpen = false
        this.showMinWindow = false
      },
      minimizeWindow: function(){
        this.showMinWindow = true
      },
      maximizeWindow: function(){
        this.showMinWindow = false
      },

      openToggles: function(e){
        e.stopPropagation();
        this.showToggles = true
      },

      enableScrollHelpers: function(){
        this.scrollHelpers = true
      },

      disableScrollHelpers: function(){
        this.scrollHelpers = false
      },
      openBGroups: function(){
        this.$root.app.doShowModal('ModalBGroups', {})
      },

      saveViewPref: function(id){
        var self = this;
        function w(d){}
        function n(){}
        this.$root.app.apiClient.put('subs/data/state', {param: 5, val: id}, w, n)
      },

     

      viewChanged(id, name, ev){

        if(id == 0){
          this.currView = this.$root.app.treeNoInbox
          this.$root.app.activateHideGroup('all')
          this.$root.app.currBundleGroup = 'All'
          this.$root.app.currBundleGroupId = 0
          this.bundleGroupsDrop = false

          this.saveViewPref(0)
          return
        } else if(id == -1){
          this.openBGroups()
          this.bundleGroupsDrop = false
        }

        var v = this.$root.app.bundleGroups.find(e => {
          return e.id == id
        })

        var arr = this.$root.app.treeNoInbox.slice(0)
        var arr2 = arr.filter(e => {
          return v.contents.includes(e.id)
        })
        this.currView = arr2

        if(!v.contents.includes(this.$root.app.fulledBundle)){
          this.$root.app.fulledBundle = this.currView[0].id
        }

        this.$root.app.activateHideGroup(v)

        this.bundleGroupsDrop = false
        this.$root.app.currBundleGroup = name
        this.$root.app.currBundleGroupId = id

        this.saveViewPref(id)

      },


      refreshData: function(){
            this.$root.app.InitialDataLoad(true);
      },


      getIndexOfRootBundle: function(id, rootId){

        var self = this

          var ind = this.$refs.rootBundleContainers.findIndex(e => {
            return e.rootId == rootId
          })

          
          var el = this.$refs.rootBundleContainers[ind].$el
          this.$refs.rootBundleContainers[ind].forceShowWatermark = true


          el.scrollIntoView({ behavior: 'smooth' })
          if(window.innerWidth < 500)
              window.scrollTo(0,0)

          var b
            function rec(id, arr){
      
                arr.forEach(e => {
                    if(e.aliasTgtId == id){
                        b = e
                        return
                    } else if(e.id == id){
                        b = e
                        return
                    }

                    if(e.children.length){
                        rec(id, e.children)
                    }
                })
                   
            }
         
            rec(id, [this.$root.app.treeNoInbox[ind]])

            if(b){
                this.$root.app.$refs.routerView.$refs.rootBundleContainers[ind].data = b;
                var tgt = this.$root.app.$refs.routerView.$refs.rootBundleContainers[ind]
                if((tgt.conts.itemsLoaded != true && tgt.conts.isRoot == false) || tgt.conts.forceLoadFromInject){
                  tgt.loadItems()
                }
                setTimeout(function(){
                  tgt.flashBundle()
                }, 500)
                setTimeout(function(){
                  self.$refs.rootBundleContainers[ind].forceShowWatermark = false
                }, 750)
               
            } else {
                this.$root.app.showModalOK({message: 'The bundle you clicked on no longer exists.'})
            }

      },

   

    
      
      
      /////////////////////////
    },
    computed: {
      minWindowTitle: function(){
        if(this.currOpenWindow != null)
          return this.$root.app.treeNoInbox[this.currOpenWindow].listName
        else
          return ''
      },
      
    },
    watch: {
      windowOpen: function(val){
        if(!val){
          this.$refs.rootBundleContainers[this.currOpenWindow].$el.classList.remove('bMinimized')
          this.bundleIndexForWindow = null;
          this.currOpenWindow = null;
        }
      }
    }
	};
</script>

<style scoped>
  .drag,
.drop {
  font-family: sans-serif;
  display: inline-block;
  border-radius: 10px;
  background: #fff;
  position: relative;
  padding: 15px;
  text-align: center;
  vertical-align: top;
}

.drag {
  color: #fff;
  cursor: move;
  background: #777;
  border-right: 2px solid #555;
  border-bottom: 2px solid #555;
}

.drop {
  background: #fff;
  border-top: 2px solid #F80;
  border-left: 2px solid #F80;
}

.dropWrapper {
  display: inline;
  cursor: pointer
}


</style>
